import { createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _mergeProps({
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xml:space": "preserve",
    x: "0px",
    y: "0px",
    version: "1.1",
    viewBox: "0 0 44 44",
    class: "icon-fi icon-fi-zoom-in"
  }, _ctx.$attrs), _cache[0] || (_cache[0] = [
    _createStaticVNode("<rect width=\"44\" height=\"44\" class=\"icon-fi--no-fill icon-fi--filled\"></rect><g transform=\"translate(-22.113 -309.529)\" class=\"\"><circle cx=\"43.1\" cy=\"330.5\" r=\"8.9\" class=\"icon-fi--no-fill icon-fi--with-stroke\"></circle><line x1=\"53.7\" x2=\"51.3\" y1=\"342.2\" y2=\"339.6\" class=\"icon-fi--stroke-linecap-round icon-fi--no-fill icon-fi--with-stroke\"></line><line x1=\"43.1\" x2=\"43.1\" y1=\"327.7\" y2=\"333.2\" class=\"icon-fi--stroke-linecap-round icon-fi--stroke-linejoin-round icon-fi--no-fill icon-fi--with-stroke\"></line><line x1=\"40.3\" x2=\"45.8\" y1=\"330.5\" y2=\"330.5\" class=\"icon-fi--stroke-linecap-round icon-fi--stroke-linejoin-round icon-fi--no-fill icon-fi--with-stroke\"></line></g>", 2)
  ]), 16))
}
export default { render: render }